import type {
  QueryNlFormsQuery,
  PostGourmetNlFormMutationVariables,
  PostHomeServicesFormMutationVariables,
  PostOperatorReportNlFormMutationVariables,
  PostNlFormMutationVariables,
  OperatorReportFormStacksQuery,
} from '@/gql/graphql';

export type PaginatedFormStackTypeResponse = Extract<QueryNlFormsQuery['queryNLForms'], {}>;
export type NeedLoveForm = Extract<PaginatedFormStackTypeResponse['rows'], {}>[number];
export type GourmetNeedLoveFormInput = Extract<PostGourmetNlFormMutationVariables['data'], {}>;
export type HomeServicesNeedLoveInput = Extract<PostHomeServicesFormMutationVariables['data'], {}> & {
  plan?: string | null;
  followupDate?: string;
  follwupTime?: string;
};
export type OperatorReportNeedLoveFormInput = Extract<PostOperatorReportNlFormMutationVariables['data'], {}> & {
  operatorId?: string;
};
export type NeedLoveFormInput = Extract<PostNlFormMutationVariables['data'], {}>;
export type OperatorReportNeedLove = Extract<OperatorReportFormStacksQuery['operatorReportFormStacks'], {}>[number];

export enum NeedLoveFormType {
  FareReview = 'fareReview',
  CancellationFee = 'cancellationFee',
  FalseTrip = 'falseTrip',
  LostItem = 'lostItem',
  UnexpectedSurge = 'unexpectedSurge',
  WantsToCloseAccount = 'wantsToCloseAccount',
  WantsToSuspendAccount = 'wantsToSuspendAccount',
  RefundDeposit = 'refundDeposit',
  RefundRideCredits = 'refundRideCredits',
  CustomerInvolvedAccident = 'customerInvolvedAccident',
  CallerPaidInCash = 'callerPaidInCash',
  DriverCarWasDirty = 'driverCarWasDirty',
  DriverCancelledButTookCaller = 'driverCancelledButTookCaller',
  CallerExperiencedTechnicalIssue = 'callerExperiencedTechnicalIssue',
  DriverWasRudeOrRefused = 'driverWasRudeOrRefused',
  DriverWasNiceButDrivingWasTooFast = 'driverWasNiceButDrivingWasTooFast',
  DriverDoesNotWantToDriveForGoGo = 'driverDoesNotWantForGoGo',
  RefundMonthlyMembershipFee = 'refundMonthlyMembershipFee',
  DriverReportingCustomerIssue = 'driverReportingCustomerIssue',
  LostItemReturned = 'lostItemReturned',
  DriverPhysically = 'driverPhysically',
  PharmacySpecialRequestAttemptFee = 'pharmacySpecialRequestAttemptFee',
}

export enum NeedLoveStatusOfComplaint {
  SelectOne = 'Select One',
  WaitingOnUberLyft = 'Waiting on Uber/Lyft',
  NoRefundOrCredit = 'No refund or credit',
  Refunded = 'Refunded - see notes',
  AdditionalActionNeeded = 'Additional action needed',
  LeftVoicemail = 'Left a voicemail',
  LeftSecondVoicemail = 'Left a 2nd voicemail',
  RideCreditIssued = 'Ride credit issued',
  ResolvedButNotCalledBack = 'Resolved but not called back',
  WaitingOnUpperManagement = 'Waiting on Upper Management',
  NeedToCollect = 'Need to collect',
  ResolvedButFollowUpWithUsOp = 'Resolved but follow up with US op',
  ResolvedButFollowUpWithFilipinoOperator = 'Resolved but follow up with Filipino Operator',
  ResolvedButFollowUpWithMexicanOp = 'Resolved but follow up with Mexican op',
}

export enum RefundApprovedOrDeny {
  Refunded = 'refunded',
  Approved = 'approved',
  Denied = 'denied',
  None = 'none',
}

export enum AdjustmentType {
  Membership = 'membership',
  NonMembership = 'nonMembership',
  None = 'none',
}
